import outputs from '../amplify_outputs.json';

// Direct-invoke Lambda targets for the SPA (Validate Item / URL check / Smart Diff).
//
// The app invokes these three functions directly via the Lambda Invoke API (using
// identity-pool credentials) to avoid the AppSync 29s timeout. The region and physical
// function names are environment-specific, so they come from amplify_outputs.json's
// `custom` section, which the backend emits per environment (see backend.addOutput in
// amplify/backend.ts).
//
// There is deliberately NO hardcoded fallback. Until 2026-08-24 this fell back to the
// Gen 1 us-east-1 names (agenticReviewFunction-dev and friends) whenever the build had
// no generated config — i.e. when the committed {"_placeholder": true} marker was used.
// Those functions were deleted with the Gen 1 decommission, so that fallback would now
// aim the app at resources that no longer exist and fail at invoke time with an opaque
// ResourceNotFoundException, rather than saying the build was misconfigured.
//
// The error is raised on ACCESS rather than on import, because tests and local builds
// legitimately run against the committed placeholder and must keep working. Only code
// that actually tries to resolve a function name needs to fail.
const custom = outputs && !outputs._placeholder && outputs.custom ? outputs.custom : null;

const MISCONFIGURED =
  'amplify_outputs.json has no `custom` block, so there is no Lambda target to invoke. ' +
  'The Amplify build generates that block (backend.addOutput in amplify/backend.ts); the ' +
  'committed file is only a {"_placeholder": true} marker. Note there is no longer a ' +
  'hardcoded fallback: the Gen 1 us-east-1 functions it used to point at were deleted on ' +
  '2026-08-24.';

// Throws on property access when the build carried no backend config.
function unavailable(what) {
  return new Proxy(
    {},
    {
      get(_target, prop) {
        throw new Error(`lambdaTargets: ${what} unavailable — ${MISCONFIGURED} (wanted: ${String(prop)})`);
      },
    }
  );
}

export const LAMBDA_REGION = custom ? custom.region : undefined;
export const LAMBDA_FUNCTIONS = custom ? custom.functions : unavailable('LAMBDA_FUNCTIONS');
